import { v4 as uuid } from "uuid";

import { IFollowUpMissionSkills } from "../../follow-ups/types";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { IMissionResource } from "../types";

export type IMissionCreateMutationParameters = {
    uuid?: string;
    title: string;
    periodStart: string;
    periodEnd: string;
    waypoint: string;
    context: string;
    description: string;
    skills: string[] | IFollowUpMissionSkills[];
    learners: string[];
};

export type IMissionCreateMutationResult = IMissionResource;

export const missionCreateMutation: IApiMutationFunction<IMissionCreateMutationParameters> = ({
    uuid: providedUuid,
    title,
    periodStart,
    periodEnd,
    waypoint,
    context,
    description,
    skills,
    learners,
}) => {
    return {
        method: "POST",
        url: "/missions",
        data: {
            uuid: providedUuid ?? uuid(),
            title,
            periodStart,
            periodEnd,
            waypoint,
            context,
            description,
            skills,
            learners,
        },
    };
};

export const useMissionCreateMutation = createApiMutationHook<
    IMissionCreateMutationParameters,
    IMissionCreateMutationResult
>(missionCreateMutation);
